import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper, Button, Fade } from "@mui/material";
import { Email, LinkedIn } from "@mui/icons-material";
import styled from "styled-components";

const CTAButton = styled(Button)`
  margin: 0.5rem;
  padding: 12px 32px;
  border-radius: 50px;
  text-transform: none;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
`;

function CTASection() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <Box sx={{ mt: 8, textAlign: "center" }}>
      <Fade in timeout={2300}>
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: "center",
            background: "linear-gradient(135deg, #0066CC 0%, #008CFF 100%)",
            color: "white",
            borderRadius: 4,
          }}
        >
          <Typography variant="h4" component="h2" gutterBottom>
            Ready to Start Your Project?
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
            Let's discuss how I can help bring your vision to life with
            cutting-edge technology and exceptional user experiences.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <CTAButton
              variant="contained"
              size="large"
              startIcon={<Email />}
              onClick={handleContactClick}
              sx={{
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "white",
                border: "2px solid rgba(255,255,255,0.3)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.3)",
                },
              }}
            >
              Contact Me
            </CTAButton>
            <CTAButton
              variant="outlined"
              size="large"
              startIcon={<LinkedIn />}
              component="a"
              href="https://www.linkedin.com/in/coryevansmith/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "white",
                borderColor: "rgba(255,255,255,0.5)",
                "&:hover": {
                  borderColor: "white",
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
            >
              Connect on LinkedIn
            </CTAButton>
          </Box>
        </Paper>
      </Fade>
    </Box>
  );
}

export default CTASection;
